import { all, call, put, fork, takeEvery } from "redux-saga/effects";
//import moment from "moment";
import {
  USER_GET_DATA,
  USER_EDIT_ITEM,
  USER_AVATAR_EDIT_ITEM,
  USER_GET_AVATAR,
  USER_REMOVE_ITEM,
  USER_VALIDATE_ITEM,
  USER_ADMIN_EDIT_ITEM,
  USER_CLEAR_DATA,
} from "../actions";

import {
  getUserDataSuccess,
  getUserDataError,
  editUserItemSuccess,
  editUserItemError,
  editUserAvatarItemSuccess,
  editUserAvatarItemError,
  getUserAvatarSuccess,
  getUserAvatarError,
  validateUserItemSuccess,
  validateUserItemError,
  editUserAdminItemSuccess,
  editUserAdminItemError,
  removeUserItemSuccess,
  removeUserItemError,
} from "./actions";

//1. Our worker saga

//* GET DATA LOGGED USER  -----------------------------------------------------------------------------
const getUserDataRequest = async (payload) => {
  //console.log(payload.payload);
  let username = payload.payload;

  return await fetch(`/mick/doctors/${username}/info`, {
    method: "get",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => {
      //console.log(response);
      if (response.ok) {
        return response.json();
      } else if (response.status === 502) {
        return "The server is not available at the moment. Please try again later.";
      } else {
        return response.text();
      }
    })
    .then((data) => {
      // console.log(data);
      return data;
    })
    .catch((error) => console.error(error));
};

function* getUserData(payload) {
  // payload will be the username from the component
  //console.log(payload);
  try {
    const response = yield call(getUserDataRequest, payload);
    //console.log(response);
    if (!response.includes("[ERROR]")) {
      yield put(getUserDataSuccess(response[0]));
    } else {
      yield put(getUserDataError(response));
    }
  } catch (error) {
    yield put(getUserDataError(error));
  }
}

//* EDIT LOGGED USER  ---------------------------------------------------------------------------------
const editUserItemRequest = async (payload) => {
  console.log("editUserItemRequest payload", payload);

  var {
    //* GENERAL
    username, //string (for identification)

    name, //string
    surname, //string
    language, //string
    affiliation, //string
    specialty, //string
    rank, //string
    gender, //string

    //* FISCAL
    vat, //string
    company, //string
    fiscalCity, //string
    fiscalAddress, //string
    fiscalPostalCode, //string
    fiscalCountry, //string
    fiscalPhone, //numeric

    //* DELIVERY
    deliveryCity, //string
    deliveryAddress, //string
    deliveryCountry, //string
  } = payload;

  if (fiscalPostalCode) {
    fiscalAddress = fiscalAddress + ", " + fiscalPostalCode;
  }

  function getQueryStringObjectType(params) {
    return Object.keys(params)
      .map((k) => {
        // if found an array
        if (Array.isArray(params[k])) {
          return `"${encodeURIComponent(k)}":[${params[k]
            .map((val) => `"${encodeURIComponent(val)}"`)
            .join(",")}]`;
        }

        // if found a number or a boolean doesn't add brackets
        if (typeof params[k] == "number" || typeof params[k] == "boolean") {
          return `"${encodeURIComponent(k)}":${encodeURIComponent(params[k])}`;
        }
        // for common strings
        return `"${encodeURIComponent(k)}":"${encodeURIComponent(params[k])}"`;
      })
      .join(",");
  }

  var formBodyGeneralData = {
    name: name, //string
    surname: surname, //string
    language: language, //string
    affiliation: affiliation, //string
    specialty: specialty, //string
    "metadata.rank": rank, //string
    "metadata.gender": gender, //string
  };

  formBodyGeneralData = getQueryStringObjectType(formBodyGeneralData);

  var formBodyFiscal = {
    "fiscal-information.vat": vat, //string
    "fiscal-information.company": company, //string
    "fiscal-information.contact.fiscalCity": fiscalCity, //string
    "fiscal-information.contact.fiscalAddress": fiscalAddress, //string
    "fiscal-information.contact.fiscalCountry": fiscalCountry, //string
    "fiscal-information.contact.fiscalPhone": fiscalPhone, //numeric
  };

  formBodyFiscal = getQueryStringObjectType(formBodyFiscal);

  var formBodyDelivery = {
    "delivery.deliveryCity": deliveryCity, //string
    "delivery.deliveryAddress": deliveryAddress, //string
    "delivery.deliveryCountry": deliveryCountry, //string
  };

  formBodyDelivery = getQueryStringObjectType(formBodyDelivery);

  var body = `username=${username}&toBeModified={${formBodyGeneralData},${formBodyFiscal},${formBodyDelivery}}`;

  // toBeModified will be parsed from txt to JS object in backend

  console.log("body", body);

  return await fetch(`/mick/doctors/modify/`, {
    method: "post",
    credentials: "same-origin",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: body,
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};

function* editUserItem(payload) {
  console.log(payload);
  try {
    const response = yield call(editUserItemRequest, payload.payload);
    // console.log(response);
    if (!response.includes("ERROR")) {
      yield put(editUserItemSuccess(response));
    } else {
      yield put(editUserItemError(response));
    }
  } catch (error) {
    console.log(error);
    yield put(editUserItemError(error));
  }
}

//* GET AVATAR LOGGED USER  ---------------------------------------------------------------------------
const getUserAvatarRequest = async (payload) => {
  let username = payload.payload;

  return await fetch(`/mick/doctors/${username}/avatar`, {
    method: "get",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  }).then((data) => {
    //console.log(data);
    return data;
  });
};

function* getUserAvatar(payload) {
  //console.log(payload);
  try {
    const response = yield call(getUserAvatarRequest, payload);

    if (response.ok) {
      yield put(getUserAvatarSuccess(response.url));
    } else {
      yield put(getUserAvatarSuccess(""));
    }
  } catch (error) {
    yield put(getUserAvatarError(error));
  }
}

//* EDIT AVATAR LOGGED USER   -----------------------------------------------------------------------------
const editUserAvatarItemRequest = async (payload) => {
  const formData = payload.payload;
  console.log(formData);

  return await fetch(`/mick/upload/avatar`, {
    method: "post",
    credentials: "same-origin",
    headers: {
      //"Access-Control-Allow-Origin": "https://35.189.226.137"
      // https://muffinman.io/uploading-files-using-fetch-multipart-form-data/
      // Remove 'Content-Type' header to allow browser to add
      // along with the correct 'boundary'
      // "Content-Type": "multipart/form-data"
    },

    body: formData,
  }).then((response) => {
    console.log(response);
    if (response.ok) {
      return response;
    } else {
      return response.text();
    }
  });
};

function* editUserAvatarItem(payload) {
  console.log(payload);
  try {
    const response = yield call(editUserAvatarItemRequest, payload);
    console.log(response);
    if (response.ok) {
      console.log("success avatar saga");
      yield put(editUserAvatarItemSuccess(response.statusText));
    } else {
      console.log(response);
      yield put(editUserAvatarItemError(response));
    }
  } catch (error) {
    yield put(editUserAvatarItemError(error));
  }
}

//* REMOVE LOGGED USER (delete own account) //--------------------------------------------------------
const removeUserItemRequest = async (payload) => {
  console.log(payload.payload);
  let username = payload.payload;

  return await fetch(`/mick/doctors/${username}/remove`, {
    method: "delete",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((error) => console.error(error));
};

function* removeUserItem(payload) {
  try {
    const response = yield call(removeUserItemRequest, payload);
    if (!response.includes("ERROR")) {
      yield put(removeUserItemSuccess(response));
    } else {
      yield put(removeUserItemError(response));
    }
  } catch (error) {
    yield put(removeUserItemError(error));
  }
}

//* VALIDATE USER (SUPER ADMIN)// ---------------------------------------------------------------------------------------------
const validateUserItemRequest = async (payload) => {
  console.log(payload.payload);
  let doctorID = payload.payload;

  return await fetch(`/mick/validation/${doctorID}`, {
    method: "get",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    })
    .catch((error) => console.error(error));
};

function* validateUserItem(payload) {
  try {
    const response = yield call(validateUserItemRequest, payload);
    if (!response.includes("ERROR")) {
      yield put(validateUserItemSuccess(response));
    } else {
      yield put(validateUserItemError(response));
    }
  } catch (error) {
    yield put(validateUserItemError(error));
  }
}

//* EDIT ADMIN USER (promoting to admin and edit managed user) (SUPER ADMIN)  ---------------------------------------------------------------------------------
const editUserAdminItemRequest = async (payload) => {
  console.log("editUserAdminItemRequest payload", payload);

  const {
    username, //string (for identification)
    isAdmin, //boolean
    managedDocs, //list/array
  } = payload;

  function getQueryStringObjectType(params) {
    return Object.keys(params)
      .map((k) => {
        // if found an array
        if (Array.isArray(params[k])) {
          return `"${encodeURIComponent(k)}":[${params[k]
            .map((val) => `"${encodeURIComponent(val)}"`)
            .join(",")}]`;
        }

        // if found a number or a boolean doesn't add brackets
        if (typeof params[k] == "number" || typeof params[k] == "boolean") {
          return `"${encodeURIComponent(k)}":${encodeURIComponent(params[k])}`;
        }
        // for common strings
        return `"${encodeURIComponent(k)}":"${encodeURIComponent(params[k])}"`;
      })
      .join(",");
  }

  var body;

  //* PROMOTING OR DOWNGRADE ADMIN STATUS
  if (isAdmin) {
    var formBodyPromotingAdmin = {
      isAdmin, //boolean
    };
    formBodyPromotingAdmin = getQueryStringObjectType(formBodyPromotingAdmin);

    body = `username=${username}&toBeModified={${formBodyPromotingAdmin}}`;
  }

  //* EDIT LIST OF MANAGED DOCTORS
  if (managedDocs) {
    var owner = managedDocs.map((item) => item.value);

    var formBodyManagedDoctors = {
      owner, //list/array
    };
    formBodyManagedDoctors = getQueryStringObjectType(formBodyManagedDoctors);

    body = `username=${username}&toBeModified={${formBodyManagedDoctors}}`;
  }

  // toBeModified will be parsed from txt to JS object in backend
  console.log("body", body);

  return await fetch(`/mick/doctors/manage/`, {
    method: "post",
    credentials: "same-origin",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: body,
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};

function* editUserAdminItem(payload) {
  console.log(payload);
  try {
    const response = yield call(editUserAdminItemRequest, payload.payload);
    // console.log(response);
    if (!response.includes("ERROR")) {
      yield put(editUserAdminItemSuccess(response));
    } else {
      yield put(editUserAdminItemError(response));
    }
  } catch (error) {
    console.log(error);
    yield put(editUserAdminItemError(error));
  }
}

//* CLEAR DATA LOGGED USER // ---------------------------------------------------------------------------------------------

function clearUserData({ payload }) {
  const { history } = payload;
}

//2. Our watcher saga
// our watcher saga spawn a new task on each action

export function* watchEditUser() {
  yield takeEvery(USER_EDIT_ITEM, editUserItem);
}

export function* watchGetUser() {
  yield takeEvery(USER_GET_DATA, getUserData);
}

export function* watchEditUserAvatar() {
  yield takeEvery(USER_AVATAR_EDIT_ITEM, editUserAvatarItem);
}

export function* watchGetUserAvatar() {
  yield takeEvery(USER_GET_AVATAR, getUserAvatar);
}

export function* watchRemoveUser() {
  yield takeEvery(USER_REMOVE_ITEM, removeUserItem);
}

export function* watchValidateUser() {
  yield takeEvery(USER_VALIDATE_ITEM, validateUserItem);
}

export function* watchEditUserAdmin() {
  yield takeEvery(USER_ADMIN_EDIT_ITEM, editUserAdminItem);
}

export function* watchClearUser() {
  yield takeEvery(USER_CLEAR_DATA, clearUserData);
}

//3. Our root saga
// single entry point to start sagas at once

export default function* rootSaga() {
  yield all([
    fork(watchGetUser),
    fork(watchEditUser),
    fork(watchEditUserAvatar),
    fork(watchGetUserAvatar),
    fork(watchRemoveUser),
    fork(watchValidateUser),
    fork(watchEditUserAdmin),
    fork(watchClearUser),
  ]);
}
